import React, { createRef } from "react";
import {
  Backdrop,
  Box,
  Button,
  Dialog,
  Divider,
  Grid,
  IconButton,
  makeStyles,
  Typography,
  FormControlLabel,
  RadioGroup,
  Radio,
  DialogActions,
  DialogContent,
  Paper,
  CircularProgress, TextField, ButtonBase,
} from "@material-ui/core";
import {getLang} from "../../../../../app/feature/constants";
import { Close as CloseIcon } from "@material-ui/icons";
import AntSwitch from "../../../../../components/switch";
import {Formik} from "formik";
import Dropzone from "react-dropzone";
import classnames from "classnames";
import VoucherTable from "./VoucherTable.container";
import * as Yup from "yup";
import {UploadImg} from "../../../../account/utils/static";

const useStyle = makeStyles((theme) => ({
  root: {
    borderRadius: 8,
    width: "100%",
    maxWidth: 1200,
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.1), 0px 8px 8px -4px rgba(16, 24, 40, 0.04)",
    [theme.breakpoints.down("xs")]: {
      minWidth: "95vw",
    },
  },
  detailsWrapper: {
    padding: theme.spacing(3, 4),
    flex: 1,
    overflowY: "auto",
    maxHeight: "calc(100vh - 200px)",
  },
  header: {
    paddingLeft: theme.spacing(3),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  actionButtons: {
    display: "flex",
    gap: theme.spacing(1),
    justifyContent: "flex-end",
    alignItems: "center"
  },
  // Import dialog styles
  dropzone: {
    border: "1px solid grey",
    borderStyle: "dashed",
    padding: "32px 16px",
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
    flexDirection: "column",
    alignItems: "center",
    "&:focus": {
      border: "1px solid blue",
      borderStyle: "dashed",
    },
  },
  // Image upload styles from basicInfoForm
  input: {
    display: "none",
  },
  mr1: {
    color: "#3A4D5480",
    padding: theme.spacing(2),
    "&:hover": {
      backgroundColor: "#C5C5C5",
    },
    display: "flex",
    flexFlow: "column",
  },
  dragging: {
    backgroundColor: "#D8D8D8",
    border: "dashed 2px",
    borderRadius: "8px",
  },
  dropzoneContainer: {
    border: "1px dashed #D8D8D8",
    borderRadius: theme.spacing(0.5),
    backgroundColor: "#D8D8D84D",
    padding: theme.spacing(2),
  },
  emailImage: {
    maxHeight: 220,
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  form: {
    backgroundColor: "#F2F4F7",
    maxHeight: "80vh",
  },
  caption: {
    color: "#98A2B3",
  },
  errorCell: {
    color: "#ff0000",
    fontWeight: 400,
    border: "1px solid #ff0000 !important",
    backgroundColor: "#ff00000d !important",
  },
  completeIndicator: {
    color: "#32D583",
    fontSize: 20,
    marginLeft: 8,
  },
  table: {
    tableLayout: "auto",
    whiteSpace: "nowrap",
    borderCollapse: "separate",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      minWidth: 0,
    },
    "& th,td": {
      fontSize: ".75rem",
      borderRight: "1px solid rgba(58, 77, 84, 0.1)",
      padding: theme.spacing(1, 2, 1, 2),
    },
    "& th": {
      color: theme.palette.text.secondary,
      fontWeight: theme.typography.fontWeightBold,
    },
    "& th:last-child, td:last-child": {
      width: 37,
      borderRight: "0px",
    },
    "& th th": {
      borderBottom: "none !important",
    },
    "& td td": {
      borderBottom: "none !important",
    },
  },
  card: {
    borderRadius: 12,
    background: "white",
    border: "1px solid #D0D5DD",
    padding: 10,
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  },
  summaryContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    columnGap: theme.spacing(1.5),
    gridRowGap: theme.spacing(2),
    rowGap: theme.spacing(2),
    marginBottom: 16,
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr 1fr",
    },
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
    },
  },
  datePicker: {
    "& .rs-picker-default .rs-picker-toggle.rs-btn": {
      borderRadius: 4,
    },
  },
  '@global': {
    '.rs-picker-daterange-menu': {
      zIndex: 9999 + ' !important',
    },
  },
  selectWrapper: {
    "& .MuiOutlinedInput-root": {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
    // make sure focus/hover states keep the same radii
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
  },
  textWrapper: {
    "& .MuiOutlinedInput-root": {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderLeft: "none", // remove the left border to avoid the double border
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderLeft: "none",
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
  },
}));

export default function ViewVoucherDialogComponent({
  isOpen,
  handleClose,
  timezone,
  lang,
  handleSubmit,
  setting,
  isFetching,

  // Import props
  isAdding,
  setIsAdding,
  file,
  setFile,
  handleFileChange,
  tableHeader,
  tableValues,
  errorField,
  errorTitles,
  showPreview,
  isValidFile,
  handleValidate,
  handleImportSubmit,
  isValidating,
  isSubmitting,
  isFileProcessing,
  handleDownloadTemplate,
  canEditVoucher,
  selectedSurvey,
  onFileExceed,
}) {
  const classes = useStyle();
  const dropzoneRef = createRef();

  const openDialog = () => {
    if (dropzoneRef.current) {
      dropzoneRef.current.open();
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      disableBackdropClick
      disableEscapeKeyDown
      classes={{
        paper: classes.root,
      }}
    >
      <Paper elevation={0} style={{ maxHeight: "100%" }}>
        <Box className={classes.header}>
          <Typography
            variant="subtitle2"
            color="primary"
            style={{ fontWeight: "bold" }}
          >
            {isAdding ?
              getLang(lang, "label.IMPORT_VOUCHER") :
              getLang(lang, "label.VIEW_VOUCHER")
            }
          </Typography>
          <IconButton color="primary" onClick={handleClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        <Divider />
        {isFetching || setting === null ? (
          <Box minHeight={400} display="flex" justifyContent="center" alignItems="center">
            <CircularProgress />
          </Box>
        ) : isAdding ? (
          <DialogContent className={classes.form} style={{ padding: 0 }}>
            <Box py={1} px={2}>
              <Box mb={3}>
                <Paper elevation={0}>
                  <Box display="flex" p={2}>
                    <Box minWidth={70}>
                      <Typography variant="body1">
                        <b>{getLang(lang, "label.STEP_NUM", { number: 1 })}:</b>
                      </Typography>
                    </Box>
                    <Box>
                      <Box mb={1}>
                        <Typography variant="body1">
                          <b>{getLang(lang, "label.GET_TEMPLATE")}</b>
                        </Typography>
                        <Typography variant="body2" className={classes.caption}>
                          {getLang(lang, "paragraph.VOUCHER_TEMPLATE_INSTRUCTION")}
                        </Typography>
                        <Typography variant="body2" className={classes.caption}>
                          {getLang(lang, "paragraph.VOUCHER_TEMPLATE_INSTRUCTION_2")}
                        </Typography>
                      </Box>
                      <Button
                        color="primary"
                        variant="contained"
                        onClick={handleDownloadTemplate}
                      >
                        {getLang(lang, "label.DOWNLOAD_TEMPLATE")}
                      </Button>
                    </Box>
                  </Box>
                </Paper>
              </Box>

              <Box mb={2}>
                <Paper elevation={0}>
                  <Box display="flex" p={2}>
                    <Box minWidth={70}>
                      <Typography variant="body1">
                        <b>{getLang(lang, "label.STEP_NUM", { number: 2 })}:</b>
                      </Typography>
                    </Box>
                    <Box flex={1}>
                      <Box mb={1}>
                        <Typography variant="body1">
                          <b>{getLang(lang, "label.UPLOAD_CSV_FILE")}</b>
                        </Typography>
                      </Box>
                      <Dropzone
                        ref={dropzoneRef}
                        noClick
                        maxFiles={1}
                        noKeyboard
                        accept={[".csv", ".xlsx"]}
                        onDrop={(acceptedFiles) => {
                          if (acceptedFiles.length) {
                            setFile(acceptedFiles[0]);
                            handleFileChange(acceptedFiles[0]);
                          } else {
                            setFile(null);
                          }
                        }}
                      >
                        {({ getRootProps, getInputProps, isDragActive }) => (
                          <section>
                            <Box
                              {...getRootProps({
                                className: classnames(classes.dropzone, {
                                  [classes.dragging]: isDragActive,
                                })
                              })}
                            >
                              <input {...getInputProps()} />

                              {file ? (
                                <Box textAlign="center">
                                  <Typography variant="body1" style={{ color: "#4CAF50", marginBottom: 8 }}>
                                    ✓ {getLang(lang, "label.FILE_SELECTED")}
                                  </Typography>
                                  <Typography variant="body2" style={{ fontWeight: "bold", marginBottom: 8 }}>
                                    {file.name}
                                  </Typography>
                                  <Typography variant="caption" style={{ color: "#666", marginBottom: 16 }}>
                                    {(file.size / 1024).toFixed(1)} KB
                                  </Typography>
                                  {isFileProcessing && (
                                    <Box mt={1}>
                                      <CircularProgress size={20} />
                                      <Typography variant="caption" style={{ marginLeft: 8 }}>
                                        {getLang(lang, "label.PROCESSING")}
                                      </Typography>
                                    </Box>
                                  )}
                                  <Box mt={2}>
                                    <Button
                                      color="primary"
                                      variant="outlined"
                                      size="small"
                                      onClick={openDialog}
                                      style={{ marginRight: 8 }}
                                    >
                                      {getLang(lang, "label.CHOOSE_DIFFERENT_FILE")}
                                    </Button>
                                    <Button
                                      color="secondary"
                                      variant="outlined"
                                      size="small"
                                      onClick={() => {
                                        setFile(null);
                                        handleFileChange(null);
                                      }}
                                    >
                                      Remove
                                    </Button>
                                  </Box>
                                </Box>
                              ) : (
                                <Box textAlign="center">
                                  <Typography
                                    variant="body2"
                                    style={{ marginBottom: 10 }}
                                  >
                                    {isDragActive
                                      ? getLang(lang, "label.DROP_HERE")
                                      : getLang(lang, "paragraph.DROP_CSV_OR_CHOOSE_FILE")
                                    }
                                  </Typography>
                                  <Button
                                    color="primary"
                                    variant="outlined"
                                    disableElevation
                                    style={{ backgroundColor: "white" }}
                                    onClick={openDialog}
                                  >
                                    {getLang(lang, "label.CHOOSE_A_FILE")}
                                  </Button>
                                </Box>
                              )}
                            </Box>
                          </section>
                        )}
                      </Dropzone>
                    </Box>
                  </Box>
                </Paper>
              </Box>
            </Box>

            <Divider />
            <DialogActions>
              <Button
                onClick={() => setIsAdding(false)}
                color="primary"
              >
                {getLang(lang, "label.BACK")}
              </Button>
              <Button
                color="secondary"
                variant="contained"
                disableElevation
                onClick={handleImportSubmit}
              >
                {getLang(lang, "label.IMPORT")}
              </Button>
            </DialogActions>
          </DialogContent>
        ) : (
          <Formik
            initialValues={{
              enabled: setting.enabled,
              method: setting.distribution_method.toString(),
              emailTitle: setting?.email_title || "",
              emailContent: setting?.email_content || "",
              emailImage: setting?.email_image || null,
              emailImagePath: "",
            }}
            enableReinitialize
            onSubmit={handleSubmit}
            validationSchema={Yup.object({
              enabled: Yup.boolean(),
              method: Yup.number().required(getLang(lang, "message.error.FORM_VALIDATE_REQUIRED")),
              emailTitle: Yup.string().nullable(),
              emailContent: Yup.string().nullable(),
              emailImage: Yup.mixed().nullable(),
            })}
          >
            {formik => (
              <form onSubmit={formik.handleSubmit}>
                <DialogContent className={classes.detailsWrapper}>
                  <Box>
                    <Grid container alignItems="center" spacing={2}>
                      <Grid item xs={3}>
                        <Typography variant="body2" color="primary">
                          {getLang(lang, "label.ENABLE_VOUCHER_DISTRIBUTION")}
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <AntSwitch
                          disabled={!canEditVoucher}
                          checked={formik.values.enabled}
                          color="primary"
                          onChange={(event) => formik.setFieldValue("enabled", event.target.checked)}
                        />
                      </Grid>
                    </Grid>
                  </Box>

                  <Box mt={2}>
                    <Grid container alignItems="center" spacing={2}>
                      <Grid item xs={3}>
                        <Typography variant="body2" color="primary">
                          {getLang(lang, "label.VOUCHER_DISTRIBUTION_METHOD")}
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <RadioGroup
                          row
                          aria-label="distribution-method"
                          name="method"
                          value={formik.values.method}
                          onChange={formik.handleChange}
                        >
                          <FormControlLabel
                            disabled={!canEditVoucher}
                            value="1"
                            control={<Radio />}
                            label={getLang(lang, "label.FIRST_IN_FIRST_OUT")}
                          />
                          <FormControlLabel
                            disabled={!canEditVoucher}
                            value="2"
                            control={<Radio />}
                            label={getLang(lang, "label.RANDOM")}
                          />
                        </RadioGroup>
                      </Grid>
                    </Grid>
                  </Box>

                  <Box mt={2}>
                    <Grid container alignItems="center" spacing={2}>
                      <Grid item xs={3}>
                        <Typography variant="body2" color="primary">
                          {getLang(lang, "label.EMAIL_TITLE")}
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <TextField
                          name="emailTitle"
                          value={formik.values.emailTitle}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.emailTitle && Boolean(formik.errors.emailTitle)}
                          helperText={formik.touched.emailTitle && formik.errors.emailTitle}
                          fullWidth
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                    </Grid>
                  </Box>

                  <Box mt={2}>
                    <Grid container alignItems="center" spacing={2}>
                      <Grid item xs={3}>
                        <Typography variant="body2" color="primary">
                          {getLang(lang, "label.EMAIL_CONTENT")}
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <TextField
                          name="emailContent"
                          value={formik.values.emailContent}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.emailContent && Boolean(formik.errors.emailContent)}
                          helperText={formik.touched.emailContent && formik.errors.emailContent}
                          fullWidth
                          variant="outlined"
                          size="small"
                          multiline
                          rows={4}
                        />
                      </Grid>
                    </Grid>
                  </Box>

                  {/* Image Upload Section */}
                  <Box mt={2}>
                    <Grid container alignItems="flex-start" spacing={2}>
                      <Grid item xs={3}>
                        <Typography variant="body2" color="primary">
                          {getLang(lang, "label.EMAIL_IMAGE")}
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <Box>
                          <Box className={classes.dropzoneContainer}>
                            <Dropzone
                              onDrop={(files) => {
                                if (files[0]) {
                                  if (files[0].size / 1024 / 1024 > 10) {
                                    onFileExceed();
                                    return;
                                  }

                                  formik.setFieldValue("emailImage", files[0]);
                                  formik.setFieldValue("emailImagePath", URL.createObjectURL(files[0]));
                                }
                              }}
                              noClick
                              noKeyboard
                              accept="image/*"
                            >
                              {({ getRootProps, isDragActive }) => (
                                <div {...getRootProps()}>
                                  <input
                                    accept="image/*"
                                    className={classes.input}
                                    id="email-image-file"
                                    type="file"
                                    name="emailImage"
                                    onChange={(e) => {
                                      let imgFile = e.currentTarget.files[0];

                                      if (imgFile.size / 1024 / 1024 > 10) {
                                        onFileExceed();
                                        return;
                                      }

                                      if (imgFile) {
                                        formik.setFieldValue("emailImage", imgFile);
                                        formik.setFieldValue("emailImagePath", URL.createObjectURL(imgFile));
                                      }
                                    }}
                                    onClick={(e) => (e.target.value = null)}
                                  />
                                  <label htmlFor="email-image-file">
                                    <ButtonBase
                                      component="span"
                                      className={classnames(classes.mr1, {
                                        [classes.dragging]: isDragActive,
                                      })}
                                    >
                                      {formik.values.emailImagePath ? (
                                        <img
                                          src={formik.values.emailImagePath}
                                          alt="emailImage"
                                          className={classes.emailImage}
                                        />
                                      ) : formik.values.emailImage &&
                                      typeof formik.values.emailImage === "string" ? (
                                        <img
                                          src={formik.values.emailImage}
                                          alt="emailImage"
                                          className={classes.emailImage}
                                        />
                                      ) : (
                                        <UploadImg color="#3A4D5480" />
                                      )}
                                      {isDragActive ? (
                                        <Box mt={1}>
                                          {getLang(lang, "label.DROP_HERE")}
                                        </Box>
                                      ) : (
                                        <Box
                                          mt={1}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                          }}
                                        >
                                          <Typography
                                            variant="body2"
                                            color="inherit"
                                            style={{
                                              textTransform: "none",
                                              marginTop: "12px",
                                            }}
                                          >
                                            <b>
                                              {getLang(lang, "paragraph.DROP_FILES")}
                                              <span>
                                              &nbsp;
                                                {getLang(lang, "paragraph.BROWSE")}
                                            </span>
                                            </b>
                                          </Typography>
                                        </Box>
                                      )}
                                    </ButtonBase>
                                  </label>
                                </div>
                              )}
                            </Dropzone>
                          </Box>
                          <Typography
                            variant="caption"
                            style={{
                              color: "#818D91",
                              marginBottom: 8,
                            }}
                          >
                            {getLang(lang, "paragraph.VOUCHER_RECOMMENDED_IMAGE_SPECS")}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>

                  <Box mt={3}>
                    <VoucherTable
                      classes={classes}
                      timezone={timezone}
                      lang={lang}
                      setIsAdding={setIsAdding}
                      selectedSurvey={selectedSurvey}
                    />
                  </Box>
                </DialogContent>
                <Divider />
                <DialogActions>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleClose}
                  >
                    {getLang(lang, "label.CLOSE")}
                  </Button>
                  {canEditVoucher && (
                    <Button
                      variant="contained"
                      color="secondary"
                      type="submit"
                    >
                      {formik.isSubmitting ? getLang(lang, "label.SAVING") : getLang(lang, "label.SAVE")}
                    </Button>
                  )}
                </DialogActions>
              </form>
            )}
          </Formik>
        )}
      </Paper>
    </Dialog>
  );
}
